import React, { useState } from 'react';
import { artworks } from '../data/products';
import ProductGrid from '../components/collection/ProductGrid';
import SEO from '../components/seo/SEO';
import './CollectionPage.css';

type Tab = 'all' | 'originals' | 'prints';

const ArtPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('all');

  const filtered = artworks.filter((a) => {
    if (activeTab === 'originals') return a.type === 'Original';
    if (activeTab === 'prints') return a.type === 'Print';
    return true;
  });

  const tabs: { id: Tab; label: string }[] = [
    { id: 'all', label: 'All' },
    { id: 'originals', label: 'Originals' },
    { id: 'prints', label: 'Prints' },
  ];

  return (
    <div className="collection-page">
      <SEO
        title="Art Collection"
        description="Original paintings and fine art prints by Micah Lynise. Museum-quality archival prints and one-of-a-kind originals."
        path="/art"
      />
      <nav className="collection-page__breadcrumb" aria-label="Breadcrumb">
        <span>Home</span>
        <span aria-hidden="true"> / </span>
        <span>Art</span>
      </nav>

      <header className="collection-page__header">
        <h1 className="collection-page__title">Artworks</h1>
        <p className="collection-page__subtitle">
          Original paintings and fine art prints inspired by nature, nostalgia, and experience.
        </p>
      </header>

      {/* Tabs */}
      <div className="collection-page__tabs" role="tablist" aria-label="Filter artwork type">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            className={`collection-page__tab ${activeTab === tab.id ? 'collection-page__tab--active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}

        {/* Sort on the right */}
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.625rem', paddingBottom: '1px' }}>
          <span className="collection-page__sort-label">Sort by</span>
          <select className="collection-page__sort-select">
            <option value="newest">Newest</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
          </select>
        </div>
      </div>

      <ProductGrid artworks={filtered} columns={3} />

      <div className="collection-page__view-all">
        <button className="collection-page__view-all-btn">
          View All Artworks
        </button>
      </div>
    </div>
  );
};

export default ArtPage;
